import { createContext, useContext } from 'react'
import type { OverlayNotchBounds } from '@shared/overlay-display-snapshot'

export const DEFAULT_PILL_HEIGHT = 40

const VIRTUAL_NOTCH_WIDTH = 180
const SNAP_ENTER_MARGIN_X = 48

export const NOTCH_EXIT_DISTANCE = 40

export interface MiniNotchRegion {
  x: number
  y: number
  width: number
  height: number
  restingHeight: number
  centerX: number
  hasNotch: boolean
}

const MiniNotchRegionContext = createContext<MiniNotchRegion | null>(null)

export const MiniNotchRegionProvider = MiniNotchRegionContext.Provider

export function useMiniNotchRegion(): MiniNotchRegion {
  const region = useContext(MiniNotchRegionContext)
  if (!region) {
    throw new Error('useMiniNotchRegion must be used inside <Mini>')
  }
  return region
}

export function getMiniNotchRegion(
  notchBounds: OverlayNotchBounds | null,
  menuBarHeight: number,
  windowWidth: number,
): MiniNotchRegion {
  if (notchBounds) {
    return {
      ...notchBounds,
      restingHeight: notchBounds.height,
      centerX: notchBounds.x + notchBounds.width / 2,
      hasNotch: true,
    }
  }

  const width = Math.min(VIRTUAL_NOTCH_WIDTH, windowWidth)
  const restingHeight = menuBarHeight > 0 ? menuBarHeight : DEFAULT_PILL_HEIGHT
  return {
    x: (windowWidth - width) / 2,
    y: 0,
    width,
    height: DEFAULT_PILL_HEIGHT,
    restingHeight,
    centerX: windowWidth / 2,
    hasNotch: false,
  }
}

export function isWithinNotchSnapZone(region: MiniNotchRegion, pillTop: number, pillCenterX: number): boolean {
  const withinX = Math.abs(pillCenterX - region.centerX) <= region.width / 2 + SNAP_ENTER_MARGIN_X
  const withinY = pillTop <= region.height
  return withinX && withinY
}
